import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellYesNo: ComponentWithProps<Props>;
  }
}

interface Props {
  value: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableCellYesNo',
  props: {
    value: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  value: boolean;
};

const TEXT_COLOR_YES = '#284132';
const BG_COLOR_YES = '#c8ffdd';

const TEXT_COLOR_NO = '#432c27';
const BG_COLOR_NO = '#f4aa99';



const text = computed(() => {
  return props.value ? 'Yes' : 'No';
});

const style = computed(() => {
  return {
    color: props.value ? TEXT_COLOR_YES : TEXT_COLOR_NO,
    backgroundColor: props.value ? BG_COLOR_YES : BG_COLOR_NO,
  };
});

return { __sfc: true,TEXT_COLOR_YES, BG_COLOR_YES, TEXT_COLOR_NO, BG_COLOR_NO, props, text, style }
}

})